export enum DomainsKey {
  nutrify = "nutrify.health",
  nutrientplaner = "nutrientplaner.ru",
  nutrientplannerCom = "nutrient-planner.com",
  nutrientplanerWorld = "nutrientplanner.world",
  stageNutrientplaner = "stage.nutrientplaner.ru",
  devNutrientplaner = "dev.nutrientplaner.ru",
  niap = "niap.ion.ru",
  niapPlanner = "niap.nplanner.ru",
  local = "localhost",
}
